angular.module("beniFornitori.components",[])
.component("beniFornitori",{
    templateUrl: "ng/components/riepilogoEControllo/beniFornitori/beniFornitori.view.html",
    bindings:{
        model: '<',
        verifica:'=',
        prodotto:'<',
        readOnly:'<'
    },
    controller: BeniEFornitori,
    controllerAs: 'beniFornitoriCtrl'
})

function BeniEFornitori(
    $configService
){
    var self = this;

    self.$onInit = function(){
        console.log(self.model)
    }

    self.expandDescription = function(){
        self.expand= !self.expand;
    }

    self.check = function(el){
        el.selected = !el.selected;
        if(el.selected){
            el.ndg= $configService.getUser().ndg;
            el.identifier= $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        }else{
            el.ndg= "";
            el.identifier= "";
            el.dataConferma = "";
        }
    }
}